'use client';

import { Path } from '@trwl/shared/lib/router';
import { motion } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { PropsWithChildren } from 'react';

export default function Template({ children }: PropsWithChildren) {
  const pathname = usePathname();
  if (pathname.startsWith(Path.USER) || pathname.startsWith(Path.CATALOG)) {
    return children;
  }
  return (
    <motion.div
      key="opacity-template"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: 'easeInOut', duration: 0.4 }}
      className={'w-full h-full'}
    >
      {children}
    </motion.div>
  );
}
